import { render } from "./ChangePassword.vue?vue&type=template&id=ae7a9ad2&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=ae7a9ad2&lang=scss"
import "./ChangePassword.vue?vue&type=style&index=1&id=ae7a9ad2&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae7a9ad2"]])

export default __exports__